const areas = (state) => {
  return state.areas.data || []
}

const areasLoading = (state) => {
  return state.areas.loading
}

const areasLastUpdate = (state) => {
  return state.areas.lastUpdate
}

const metrics = (state) => {
  return state.metrics.data || []
}

const metricsLoading = (state) => {
  return state.metrics.loading
}

const metricsLastUpdate = (state) => {
  return state.metrics.lastUpdate
}

const categories = (state) => {
  return state.categories.data || []
}

const categoriesLoading = (state) => {
  return state.categories.loading
}

const categoriesLastUpdate = (state) => {
  return state.categories.lastUpdate
}

const rubrics = (state) => {
  return state.rubrics.data || []
}

const rubricsLoading = (state) => {
  return state.rubrics.loading
}

const rubricsLastUpdate = (state) => {
  return state.rubrics.lastUpdate
}

const metricsPJ = (state) => {
  return state.metricsPJ.data || {}
}

const metricsPJLoading = (state) => (id_metric) => {
  if (state.metricsPJ.data[id_metric]) {
    return state.metricsPJ.data[id_metric].loading
  }
  return false
}

const metricsPJLastUpdate = (state) => (id_metric) => {
  if (state.metricsPJ.data[id_metric]) {
    return state.metricsPJ.data[id_metric].lastUpdate
  }
  return false
}

const metricsArea = (state) => {
  return state.metricsArea.data || {}
}

const metricsAreaLoading = (state) => (id_metric) => {
  if (state.metricsArea.data[id_metric]) {
    return state.metricsArea.data[id_metric].loading
  }
  return false
}

const metricsAreaLastUpdate = (state) => (id_metric) => {
  if (state.metricsArea.data[id_metric]) {
    return state.metricsArea.data[id_metric].lastUpdate
  }
  return null
}

export const metricsFilial = (state) => {
  return state.metricsFilial.data || {}
}

export const metricsFilialLoading = (state) => (id_metric) => {
  if (state.metricsFilial.data[id_metric]) {
    return state.metricsFilial.data[id_metric].loading
  }
  return false
}

export const metricsFilialLastUpdate = (state) => (id_metric) => {
  if (state.metricsFilial.data[id_metric]) {
    return state.metricsFilial.data[id_metric].lastUpdate
  }
  return null
}

const dre = (state) => {
  return state.dre.data || {}
}

const dreLoading = (state) => {
  return state.dre.loading
}

const dreLastUpdate = (state) => {
  return state.dre.lastUpdate
}

export const valuationOffice = (state) => {
  return state.valuationOffice.data || {}
}

export const valuationOfficeLoading = (state) => {
  return state.valuationOffice.loading
}

export const valuationOfficeLastUpdate = (state) => {
  return state.valuationOffice.lastUpdate
}

export const valuationProfessional = (state) => {
  return state.valuationProfessional.data || {}
}

export const valuationProfessionalLoading = (state) => {
  return state.valuationProfessional.loading
}

export const valuationProfessionalLastUpdate = (state) => {
  return state.valuationProfessional.lastUpdate
}

export const margin = (state) => {
  return state.margin.data || []
}

export const marginLoading = (state) => {
  return state.margin.loading
}

export const marginLastUpdate = (state) => {
  return state.margin.lastUpdate
}

export const showBatchCategories = (state) => {
  return state.batchCategories.show || false
}

export const quantityBatchCategories = (state) => {
  return state.batchCategories.quantity || 0
}

export const categoriesIdsBatchCategories = (state) => {
  return state.batchCategories.categories_ids || []
}

export const optionsEditBatchCategories = (state) => {
  return state.batchCategories.optionsEdit || []
}

export {
  areas,
  areasLoading,
  areasLastUpdate,
  metrics,
  metricsLoading,
  metricsLastUpdate,
  categories,
  categoriesLoading,
  categoriesLastUpdate,
  rubrics,
  rubricsLoading,
  rubricsLastUpdate,
  metricsPJ,
  metricsPJLoading,
  metricsPJLastUpdate,
  metricsArea,
  metricsAreaLoading,
  metricsAreaLastUpdate,
  dre,
  dreLoading,
  dreLastUpdate,
}
